import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHAgrupamientoUpd = async (credentials, data) => {
  const body = {
    service: "RNHAgrupamientoUpd",
    params: {
      // Sin el Id el back no sabe a cual modificar: es lo que separa un Upd de un Ins.
      rnhAgrupamientoId: data?.id,
      rnhAgrupamientoCod: data?.cod || null,
      rnhAgrupamientoNombre: data?.nombre || null,
      rnhAgrupamientoVersion: data?.version ?? null,
    },
  };

  return respuestaDe(await axiosPost(body, credentials));
};
